import React, { useState } from 'react';
import Icon from '@/general-ui/icons/icon';
import { ICONS } from '@/general-ui/icons/types';
import toastTrigger from '@/general-ui/toast/toast-trigger';
import styles from './text-copy-box.module.css';
import Text from '@ui/text/text/text';
import { EToastTypes } from '@ui/toast/toast.types';

interface TextCopyBoxProps {
  textToCopy: string;
  label?: string;
  className?: string;
}

const TextCopyBox: React.FC<TextCopyBoxProps> = ({ textToCopy, label, className = '' }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
      toastTrigger('Failed to copy', {
        type: EToastTypes.error,
        autoClose: 3000,
        description: 'Could not copy text to clipboard',
      });
    }
  };

  return (
    <div className={`${styles.textCopyBoxContainer} ${className}`}>
      {label && (
        <Text tag="label" className={styles.label}>
          {label}
        </Text>
      )}
      <div className={styles.mainContent}>
        <pre className={styles.textDisplayBox} title={textToCopy}>
          {textToCopy}
        </pre>
        <button onClick={handleCopy} className={styles.copyButton} aria-label="Copy text" title="Copy to clipboard">
          <Icon
            name={copied ? ICONS.CHECK : ICONS.COPY}
            size={18}
            color={copied ? 'var(--semantic-green-500)' : 'var(--gray-500)'}
          />
        </button>
      </div>
    </div>
  );
};

export default TextCopyBox;
